import React from 'react';
import PropTypes from 'prop-types';
import {chunk} from 'lodash';

import Page from './Page';
import Translation from './Translation';

function renderVariantSpecs(facetId, item) {
	const property = item.properties[facetId];
	if (!property) {
		return null;
	}
	return (
		<li key={facetId}>{property.descriptionlong}</li>
	);
}

function renderItem({title, rep, numbers}, variantSpecs, items, index) {
	const item = items[rep];
	if (!item) {
		return null;
	}

	return (
		<li key={index} className="slx-mounting-variants__variant">
			<div className="slx-mounting-variants__variant-image-wrapper">
				{item.properties[332] && (
					<img
						className="slx-mounting-variants__variant-image"
						src={item.properties[332].image}
						/>
				)}
			</div>
			<div className="slx-mounting-variants__variant-text">
				<div
					className="slx-mounting-variants__variant-numbers"
					dangerouslySetInnerHTML={{__html: numbers}}
				/>
				<ul className="slx-mounting-variants__variant-specs">
					{variantSpecs.map(facetId => renderVariantSpecs(facetId, item))}
				</ul>
			</div>
		</li>
	);
}

function Variants({items, content, startPageNumber, maxPageNumber}) {
	const {variants, variantSpecs} = content;

	if (!variants) {
		return null;
	}

	return chunk(variants, 8).map((pageVariants, pageIndex) => (
		<Page
			key={pageIndex}
			content={content}
			number={startPageNumber + pageIndex}
			maxPageNumber={maxPageNumber}
		>
			<div className="slx-mounting-variants">
				<h1><Translation name="variations" /></h1>
				<ul className="slx-mounting-variants__list">
					{pageVariants.map((variant, index) => renderItem(variant, variantSpecs, items, index))}
				</ul>
			</div>
		</Page>
	));
}

Variants.propTypes = {
	items: PropTypes.object.isRequired,
	content: PropTypes.object.isRequired,
	startPageNumber: PropTypes.number.isRequired,
	maxPageNumber: PropTypes.number.isRequired,
};

export default React.memo(Variants);

export function numPages({content: {variants = []}}) {
	return Math.ceil(variants.length / 8);
}
